import React from 'react'
import TableImages from './TableImage'

function hasImages(images) {
  return images.filter((i) => i.refRequestFileId === 3).length > 0
}

function RequestComponent({ state, onChangeRoute, onChangeForm, onChangeState, onSave, onAttach, onDownloadDecision }) {
  // console.log(state)
  return (
    <div className="content-line">
      <div className="container-content">
        <div className="content-line">
          <h2 className='primary-color'>Solicitud No. {state.data.rad}</h2>
          <div className='line line-33'>
            <label>Solicitur No.</label>
            <div className="div-input-form">
              <input defaultValue={state.data.rad} disabled={true} />
            </div>
          </div>
          <div className='line line-33'>
            <label>Tipo solicitud</label>
            <div className="div-input-form">
              <input
                defaultValue={state.data.refRequestType.name}
                disabled={true}
              />
            </div>
          </div>
          <div className='line line-33'>
            <label>Fecha solicitud</label>
            <div className="div-input-form">
              <input
                defaultValue={state.data.createdAt.split('T')[0]}
                disabled={true}
              />
            </div>
          </div>
          <div className='line line-33'>
            <label>Estado de la solicitud</label>
            <div className="div-input-form">
              <input
                defaultValue={state.data.refRequestState.name}
                disabled={true}
              />
            </div>
          </div>
          <div className='line line-33'>
            <label>Correo electrónico</label>
            <div className="div-input-form">
              <input
                defaultValue={state.data.email}
                disabled={true}
              />
            </div>
          </div>
          <div className='line line-33'>
            <label>Direccion del permiso</label>
            <div className="div-input-form">
              <input
                defaultValue={state.data.address}
                disabled={true}
              />
            </div>
          </div>
          {
            state.data.isCompany &&
            <>
              <div className='line line-50'>
                <label>NIT</label>
                <div className="div-input-form">
                  <input
                    defaultValue={state.data.nit}
                    disabled={true}
                  />
                </div>
              </div>
              <div className='line line-50'>
                <label>Razón social</label>
                <div className="div-input-form">
                  <input
                    defaultValue={state.data.socialReason}
                    disabled={true}
                  />
                </div>
              </div>
            </>
          }
          <div className='line line-100'>
            <label>Descripción de la solicitud</label>
            <div className="div-input-form">
              <textarea
                style={{ border: 'none', width: '100%', outline: 'none' }}
                rows={5}
                disabled={true}
                defaultValue={state.data.description}
              ></textarea>
            </div>
          </div>
          <div className='line line-100' style={{ display: 'flex' }}>
            <div className="button-primary line line-20 text-center">
              <div className="div-input-button" style={{ backgroundColor: 'var(--primary-color)' }}>
                <input type="button" value="Anexar archivo" style={{ backgroundColor: 'var(--primary-color)', color: 'white' }} onClick={() => document.getElementById('file').click()} />
                <input type='file' id="file" onChange={(e) => onAttach(e.target.files)} style={{ display: 'none' }} />
              </div>
            </div>
          </div>
          <div className='line line-100'>
            <h3 className='primary-color'>Archivos solicitud</h3>
            <TableImages images={state.images.filter(f => f.refRequestFileId < 3)} />
          </div>
          {
            hasImages(state.images) &&
            <>
              <h3 className='primary-color'>Imágenes de la visita</h3>
              <div className='request-image-list div-input-form'>
                {
                  state.images.filter(i => i.refRequestFileId === 3).map(i =>
                    <img key={`i-${i.id}`} src={i.url} alt={i.name} />
                  )
                }
              </div>
            </>
          }
          {
            state.data.lat &&
            <div className='line line-100'>
              <h3 className='primary-color'>Ubicación</h3>
              <div className='flex-center div-input-form'>
                <div id='map-resolve' style={{ height: '450px', flex: 1 }}></div>
                <div id='street-view-resolve' style={{ height: '450px', flex: 1 }}></div>
              </div>
            </div>
          }
          {
            state.data.refRequestStateId === 1 &&
            <>
              <h3 className='primary-color'>Visita</h3>
              <div className='line line-100' style={{ display: 'flex' }}>
                <label>¿Se programa visita de inspección?</label>
                {
                  state.progVisit ?
                    <span onClick={() => onChangeState('progVisit', false)} className='far fa-check-square primary-color' style={{ fontSize: '30px', marginLeft: '16px' }}></span>
                    : <span onClick={() => onChangeState('progVisit', true)} className='far fa-square' style={{ fontSize: '30px', marginLeft: '16px', color: 'rgba(0,0,0,0.6' }}></span>
                }
              </div>
              {
                state.progVisit &&
                <div className='line line-33'>
                  <label>Fecha de la visita</label>
                  <div className="div-input-form">
                    <input
                      value={state.data.visitDate}
                      type='date'
                      onChange={e => onChangeForm('visitDate', e.target.value)}
                    />
                  </div>
                </div>
              }
            </>
          }
          {
            !state.progVisit &&
            <>
              <h3 className='primary-color'>Decisión</h3>
              <div className='line line-100' style={{ display: 'flex' }}>
                <label>¿La solicitud se aprueba?</label>
                {
                  state.data.isAppruved ?
                    <span onClick={() => onChangeForm('isAppruved', false)} className='far fa-check-square primary-color' style={{ fontSize: '30px', marginLeft: '16px' }}></span>
                    : <span onClick={() => onChangeForm('isAppruved', true)} className='far fa-square' style={{ fontSize: '30px', marginLeft: '16px', color: 'rgba(0,0,0,0.6' }}></span>
                }
              </div>
              <div className='line line-100'>
                <label>Descripción de la decisión</label>
                <div className="div-input-form">
                  <textarea
                    style={{ border: 'none', width: '100%', outline: 'none' }}
                    rows={5}
                    value={state.data.decision}
                    onChange={e => onChangeForm('decision', e.target.value)}
                    disabled={state.data.refRequestStateId === 4}
                  ></textarea>
                </div>
              </div>
            </>
          }
          <div className='line line-100' style={{ display: 'flex',  }}>
            <div className="button-secondary line line-20 text-center">
              <div className="div-input-button">
                <input type="button" value="Descargar Decisión" onClick={onDownloadDecision} />
              </div>
            </div>
            <div className="button-secondary line line-20 text-center">
              <div className="div-input-button" >
                <input type="button" value="Cargar Decisión" onClick={() => document.getElementById('file').click()} />
              </div>
            </div>
          </div>

          <div className='line line-100' style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <div className="button-secondary line line-20 text-center">
              <div className="div-input-button">
                <input type="button" value="Cancelar" onClick={() => onChangeRoute('/ep/requests')} />
              </div>
            </div>
            <div className="button-primary line line-20 text-center">
              <div className="div-input-button" style={{ backgroundColor: 'var(--primary-color)' }}>
                <input type="button" value="Guardar" style={{ backgroundColor: 'var(--primary-color)', color: 'white' }} onClick={onSave} />
              </div>
            </div>
          </div>
          <div className='line line-100'>
            <div style={{ height: '30px' }}></div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default RequestComponent
